import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrQuickReturnOrderComponent } from './kn-br-quick-return-order.component';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormErrorsModule, ListNavigationModule, SpinnerModule } from '@spartacus/storefront';
import { KnBrCustomPipesModule } from 'src/app/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';

@NgModule({
    imports: [
        CommonModule,
        SpinnerModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        I18nModule,
        FormErrorsModule,
        NgbModule,
        ListNavigationModule,
        KnBrCustomPipesModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBr360ReturnHistoryComponent: {
                    component: () => import('./kn-br-quick-return-order.component').then((c) => c.KnBrQuickReturnOrderComponent),
                },
            },
        } as CmsConfig),
        KnBrQuickReturnOrderComponent,
    ],
})
export class KnBrQuickReturnOrderModule {}
